import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="section fp-auto-height myContent" id="section4">
      <footer>
        <div className="ft_link">
          <a href="">협업툴 모노티</a>
          <a href="">회사소개</a>
          <Link to={"/policy"}>이용약관</Link>
          <Link to={"/policy"}>개인정보처리방침</Link>
        </div>
        <div className="ft_info">
          <div className="ft_info1">
            <span className="font_18 font500 pdb_30">대표전화</span>
            <span className="font_30 font700 font_color_1 pdb_40">042.272.5555</span>
            <span className="font_18 font300">
              상담시간: AM 09:00 ~ PM 5:00
              <br />
              (토,일,공휴일 휴무)
            </span>
          </div>
          <div className="ft_info2">
            <span className="font_16 font400 pdb_70">
              상호명: 노타이틀&nbsp;&nbsp;&nbsp;&nbsp; 대표자명: 조윤호&nbsp;&nbsp;&nbsp;&nbsp;
              사업자등록번호 : 118-87-01602
              <br />
              통신판매업: 제 2022-대전서구-1316 호
              <br />
              주소: 대전광역시 서구 둔산남로 176, 2층(탄방동) &nbsp;&nbsp;&nbsp;&nbsp; 팩스:
              0303-3130-7344 &nbsp;&nbsp;&nbsp;&nbsp; 대표메일: helpnotitle@gmail.com
            </span>
            <span className="font_14 font300">COPYRIGHT ⓒ 2023 No-title. All right Reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
